<template>
  <div style="height: 100%" fluid>
    <ag-grid-vue
      :style="{ width, height }"
      class="ag-theme-alpine"
      :defaultColDef="defaultColDef"
      :columnDefs="columnDefs"
      :rowData="rowData"
      :animateRows="true"
      :rowBuffer="1"
      :paginationAutoPageSize="true"
      :pagination="true"
      :isExternalFilterPresent="isExternalFilterPresent"
      :doesExternalFilterPass="doesExternalFilterPass"
      rowSelection="multiple"
      @grid-ready="onGridReady"
      @cellDoubleClicked="onCellDoubleClick"
      @filterChanged="$emit('filterChanged', gridApi.getModel())"
    ></ag-grid-vue>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import AppBar from "@/components/AppBar";
  import agGridActionButton from "@/components/agGridActionButton";
  import expandedToolbar from "@/components/expandedToolbar.vue";
  import { AgGridVue } from "ag-grid-vue";
  import moment from "moment";

  export default {
    components: {
      AppBar,
      AgGridVue,
      agGridActionButton,
      expandedToolbar,
    },
    computed: {
      ...mapGetters(["currentUser", "currentUserData"]),
    },
    props: [
      "agGridData",
      "agGridDataLoading",
      "columnDefs",
      "search",
      "searchTimeout",
    ],
    data: () => ({
      // AG-Grid
      rowData: null,
      columnApi: null,
      gridApi: null,
      defaultColDef: {
        sortable: true,
        filter: true,
        resizable: true,
        autoHeight: true,
      },
      width: "100%",
      height: "100%",
      searchDebounce: null,
    }),
    watch: {
      agGridData: function (newData, oldData) {
        if (this.agGridData.length > 0 && this.gridApi != null) {
          this.setGridData();
        }
      },
      search: function () {
        this.onQuickFilterChanged();
      },
    },
    mounted() {
      if (this.agGridData.length > 0 && this.gridApi != null) {
        this.setGridData();
      }
    },
    methods: {
      setGridData() {
        const rowData = this.agGridData;
        this.gridApi.setRowData(rowData);
        setTimeout(() => {
          var allColumnIds = [];
          this.columnApi.getAllColumns().forEach(function (column) {
            allColumnIds.push(column.colId);
          });
          this.columnApi.autoSizeColumns(allColumnIds, false);
          this.$emit("filterChanged", this.gridApi.getModel());
        }, 50);
      },
      onQuickFilterChanged() {
        clearTimeout(this.searchDebounce);
        this.searchDebounce = setTimeout(() => {
          this.gridApi.setQuickFilter(this.search);
        }, this.searchTimeout);
      },
      onGridReady(params) {
        this.gridApi = params.api;
        this.columnApi = params.columnApi;
        if (this.agGridData.length > 0) {
          setTimeout(() => {
            this.setGridData();
          }, 200);
        }
      },
      autoSizeColumnsAGGRID() {
        // this.gridApi.sizeColumnsToFit();
        var allColumnIds = [];
        this.columnApi.getAllColumns().forEach(function (column) {
          allColumnIds.push(column.colId);
        });
        this.columnApi.autoSizeColumns(allColumnIds, false);
      },
      onCellDoubleClick(cell) {
        this.$store.dispatch("setSelectedRowData", cell.data);
        this.$emit("cellDoubleClick");
      },
      isExternalFilterPresent() {
        return this.imageFilterValue !== "All";
      },
      doesExternalFilterPass(node) {
        switch (this.imageFilterValue) {
          case 1:
            return node.data.hasImage == 1;
          case 0:
            return node.data.hasImage == 0;
          default:
            return true;
        }
      },
      getSelectedRows() {
        this.$emit("returnedSelectedRows", this.gridApi.getSelectedRows());
      },
    },
  };
  window.hasImageFormatter = function hasImageFormatter(params) {
    if (params.data.hasImage == 1) {
      return true;
    } else {
      return false;
    }
  };
  window.roleFormatter = function roleFormatter(params) {
    switch (params.data.role) {
      case "Admin":
        return "Admin";
        break;
      default:
        return "";
        break;
    }
  };
  window.created_atFormatter = function created_atFormatter(params) {
    return moment
      .utc(params.data.created_at)
      .local()
      .format("MMMM Do YYYY, h:mm:ss a");
  };
  window.updated_atFormatter = function updated_atFormatter(params) {
    return moment
      .utc(params.data.updated_at)
      .local()
      .format("MMMM Do YYYY, h:mm:ss a");
  };
</script>

<style>
  .croppa-container {
    margin-left: auto;
    margin-right: auto;
    position: relative;
  }

  .croppa-container canvas {
    border: 1px solid;
  }
</style>
